/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum StopVerb {
    ASAP = 1,
    DELIVER_DIRECT = 2,
    PROTECT = 3,
    OPEN = 4,
    CLOSE = 5,
    READY_NOW = 6,
    HOT = 7,
    WINDOW = 8,
}
